import axios from "axios";
import { canShowStudyDrugMenuItem } from "../../../modules/utils";

//Constants
const SET_DIET_DIARY_MENU_ITEMS = "SET_DIET_DIARY_MENU_ITEMS";
const LOGOUT = "LOGOUT";
const RESET_STATE = "RESET_STATE";

//Acessors
const getDietMenuItems = (state) => state?.dietMenuItems;
const getParticipantDateOfEnrollment = (state) =>
  state?.smartPageHeaderReducer?.participantDateOfEnrollment;
const getStudies = (state) => state?.loginReducer?.studies;

//Default state
const initialState = {
  dietMenuItems: null,
};

export const dietDiaryMenuItemsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DIET_DIARY_MENU_ITEMS: {
      const { dietMenuItems } = action;

      return Object.assign({}, state, {
        dietMenuItems: dietMenuItems,
      });
    }
    case LOGOUT:
      return initialState;
    case RESET_STATE:
      return initialState;
    default:
      return state;
  }
};

//Mutators
export const resetState = () => (dispatch) => {
  return dispatch({
    type: RESET_STATE,
  });
};

const fetchDietDiaryMenuItems = () => (dispatch, getState) => {
  if (!canShowStudyDrugMenuItem(getStudies(getState())[0].status)) {
    return;
  }

  return axios.get(`/api/dietmenu`).then(({ data }) => {
    dispatch({ type: SET_DIET_DIARY_MENU_ITEMS, dietMenuItems: data });
  });
};

export const mapStateToProps = (state) => {
  return {
    dietMenuItems: getDietMenuItems(state),
    participantDateOfEnrollment: getParticipantDateOfEnrollment(state),
  };
};

export const mapDispatchToProps = {
  fetchDietDiaryMenuItems,
  resetState,
};
